import { TradeInPreviewAcquisition } from '@carvana/merch-contracts';
import isTradeActive from '~/utilities/common/isTradeActive';
import shouldShowTradeIncentive from '~/utilities/common/shouldShowTradeIncentive';

type OwnArgs = {
  isTradeInApplied: boolean;
  price: number;
  selectedTrade: TradeInPreviewAcquisition | null;
  totalDiscount: number;
};

export default function getHasHighNetTrade({
  isTradeInApplied,
  price,
  selectedTrade,
  totalDiscount
}: OwnArgs): boolean {
  const { equity = 0, lifeCycleState, tradeIncentive } = selectedTrade ?? {};
  const isActiveTrade = isTradeActive(lifeCycleState);
  const showTradeIncentive = shouldShowTradeIncentive({
    isActiveTrade,
    isTradeInApplied,
    tradeIncentive: tradeIncentive ?? 0
  });
  const discountWithIncentive = showTradeIncentive
    ? totalDiscount + (tradeIncentive ?? 0)
    : totalDiscount;
  const priceWithDiscountsApplied = price - discountWithIncentive;

  const hasHighNetTrade = isActiveTrade && equity > priceWithDiscountsApplied;

  return isTradeInApplied && hasHighNetTrade;
}
